import { render, staticRenderFns } from "./ExpenseTracker.vue?vue&type=template&id=af2745fa&"
import script from "./ExpenseTracker.vue?vue&type=script&lang=js&"
export * from "./ExpenseTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports